import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, OptionCard, OptionCardContent, ProgressBar } from '../../components/ui';
import type { MotivationLevel } from '../../types';

const OPTIONS: { value: MotivationLevel; label: string }[] = [
  { value: 'not_motivated', label: 'Not motivated at all' },
  { value: 'a_bit_motivated', label: 'A bit motivated' },
  { value: 'somewhat_motivated', label: 'Somewhat motivated' },
  { value: 'very_motivated', label: 'Very motivated' },
  { value: 'extremely_motivated', label: 'Extremely motivated' },
];

export function MotivationScreen() {
  const navigate = useNavigate();
  const { onboarding, updateOnboarding, nextStep } = useStore();

  const handleSelect = (value: MotivationLevel) => {
    updateOnboarding({ motivationLevel: value });
  };

  const handleContinue = () => {
    if (onboarding.motivationLevel) {
      nextStep();
      navigate('/onboarding/science');
    }
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={9} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-2">How motivated are you to change right now?</h1>
        <p className="text-secondary mb-8">We adjust the plan to your energy.</p>

        <div className="space-y-3 mb-8">
          {OPTIONS.map(({ value, label }) => (
            <OptionCard
              key={value}
              selected={onboarding.motivationLevel === value}
              onClick={() => handleSelect(value)}
            >
              <OptionCardContent title={label} />
            </OptionCard>
          ))}
        </div>
      </div>

      <Button onClick={handleContinue} disabled={!onboarding.motivationLevel}>
        Continue
      </Button>
    </div>
  );
}
